/* eslint-disable import/prefer-default-export */
export const GET_CUSTOMER_SESSION_DETAILS_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
export const GET_CUSTOMER_USAGE_WITH_DATE_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
